// extracted by mini-css-extract-plugin
export var testimonial = "testimonial-module--testimonial--bru-j";
export var testimonial_imgAuthorWrap = "testimonial-module--testimonial_imgAuthorWrap--2oz5I";
export var testimonial_blockquote = "testimonial-module--testimonial_blockquote--2KRgI";
export var testimonial_info = "testimonial-module--testimonial_info--1xWq4";
export var testimonial_authorName = "testimonial-module--testimonial_authorName--1lNAs";
export var inner = "testimonial-module--inner--2SQFA";
export var jsAnimInit = "testimonial-module--jsAnimInit--2I76F";
export var logoWrap = "testimonial-module--logoWrap--33GHs";